import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import { getDpaCategory, createProduct, getProductConfigs } from '@/api/open'

export default {
    components: {
        MaterialSelect,
    },
    props: {
        showCreateProductForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ })
        }
    },
    created() {
        console.log('进入数据',this.model)
        this.actionName = '新建'
     },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            actionName: '操作',
            rules: {
                "product_platform_id": [{ required: true, message: '请填写商品库ID', trigger: 'change' }],
                "product_type": [{ required: true, message: '请填写商品库分类', trigger: 'change' }],
                "dpa_category": [{ required: true, message: '请选择商品类目', trigger: 'change' }],
                "name": [{ required: true, message: '请填写剧名称', trigger: 'change' }],
                'profession.micro_app_link': [{ required: true, message: '请填写字节小程序推广链接', trigger: 'change' }],
                'profession.copyright_owner': [{ required: true, message: '请填写版权方主体名称', trigger: 'change' }],
                'profession.has_paid_content': [{ required: true, message: '请选择变现模式', trigger: 'change' }],
                'profession.has_motivation_content': [{ required: true, message: '请选择是否包含网赚内容', trigger: 'change' }],
                'profession.playlet_gender': [{ required: true, message: '请选择短剧男女频', trigger: 'change' }],
                'profession.playlet_num': [{ required: true, message: '请填写剧类集数', trigger: 'change' }],
                'profession.playlet_duration': [{ required: true, message: '请填写单集剧集时长', trigger: 'change' }],
                'profession.starting_unlock_episode': [{ required: true, message: '请填写起始解锁集数', trigger: 'change' }],
                'profession.start_pay_playlet': [{ required: true, message: '请填写起始付费集数', trigger: 'change' }],
                'price_info.price': [{ required: true, message: '请填写付费价格', trigger: 'change' }],
                'image_url': [{ required: true, message: '请选择商品图片', trigger: 'change' }],
            },
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            getMaterials: [],
            xcxNavs: [],
            productConfigs: [],
            copyright_owners: ['抖音视界', '点众快看'],
            product_types: [
                {'type':1, 'name':'番茄商品库'},
                {'type':2, 'name':'点众商品库'},
                {'type':3, 'name':'掌阅商品库'},
            ],
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
     
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            console.log('提交的数据 this.model', this.model)
            let data = {
                "advertiser_ids": this.model.advertiser_ids,
                "product_platform_id": this.model.product_platform_id,
                "product_info": this.model.profession,
                "price_info": this.model.price_info,
                "product_type": this.model.product_type,
                "is_copy": this.model.is_copy,
            }

            // 获取类别名称和 ID
            let categoryNames = this.getCategoryNames(this.xcxNavs, this.model.dpa_category);

            data.product_info.name = this.model.name
            data.product_info.image_url = this.model.image_url
            data.product_info.first_category_id = this.model.dpa_category[0]
            data.product_info.first_category = categoryNames.first

            data.product_info.second_category_id = this.model.dpa_category[1]
            data.product_info.second_category = categoryNames.second 

            data.product_info.third_category_id = this.model.dpa_category[2]
            data.product_info.third_category = categoryNames.third 

            console.log('提交的数据 data', data)

            this.result.success = []
            this.result.errors = []

            this.loading = true
            createProduct(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                    //出现弹窗，提示结果不关闭，关闭弹窗，才刷新
                    this.showResult = true
                    // this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
                this.showSubmit = false
            }).catch(() => {
                this.loading = false
                this.showSubmit = true
            })
        },
        closerResult () {
            this.showResult = false
            this.$emit('success')
            this.close()
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showCreateProductForm', false)
        },
        clickPane () {
            // console.log(key);
        },
        findCategoriesByName(data, categoryName) {
            for (let category of data) {
              if (category.category_name === categoryName) {
                return category.categories || [];
              }
              if (category.categories) {
                const result = this.findCategoriesByName(category.categories, categoryName);
                if (result.length) {
                  return result;
                }
              }
            }
            return []; // 如果没有找到，返回空数组
        },
        getXcxNavs() {
            this.xcxNavs = []
            let navs = []
            //需要获取类目: 2,3,5是字节小程序
            navs = this.navs.list

            navs.forEach(element => {
                //一级分类
                let firstCategories = []
                element.subs.forEach(element2 => {
                    //二级分类
                    let categories = []
                    element2.subs.forEach(element3 => {
                        categories.push({
                            "value": element3.id,
                            "label": element3.name,
                            "disabled": false
                        })
                    })

                    firstCategories.push({
                       "value": element2.id,
                       "label": element2.name,
                        "disabled": false,
                        "children": categories
                    })
                })

                let item = {
                    "value": element.id,
                    "label": element.name,
                    "disabled": false,
                    "children": firstCategories
                }

                this.xcxNavs.push(item)
            });
            // console.log('navs', this.xcxNavs)
        },
        changePlatformId () {
           
            if (this.model.product_platform_id ) {
                // console.log('进入', this.model.product_platform_id)
                this.navs = []
                this.xcxNavs = []

                this.loading = true
                //获取分类
                getDpaCategory({advertiser_id:this.model.advertiser_ids[0], platform_id:this.model.product_platform_id, adv_type: this.model.show_type}).then(res => {
                    this.navs = res.data || []
                    this.getXcxNavs()
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
         // 获取选中的分类名称
        getCategoryNames(options, selectedIds) {
            let categoryNames = {
                first: '',
                second: '',
                third: ''
            };

            // 遍历选中的 ID 并找到对应的名称
            function findCategoryName(options, selectedIds, level) {
                for (let option of options) {
                    if (selectedIds.includes(option.value)) {
                        // 根据级别设置名称
                        if (level === 1) {
                            categoryNames.first = option.label;
                        } else if (level === 2) {
                            categoryNames.second = option.label;
                        } else if (level === 3) {
                            categoryNames.third = option.label;
                        }
                        // 如果有子分类，继续查找
                        if (option.children && option.children.length) {
                            findCategoryName(option.children, selectedIds, level + 1);
                        }
                    }
                }
            }

            // 开始查找
            findCategoryName(options, selectedIds, 1);

            return categoryNames;
        },
        changePayModel() {
            if (this.model.profession.has_paid_content == 1) {
                this.model.profession.has_motivation_content = 1
            } else {
                this.model.profession.has_motivation_content = 2
            }
        },
        changeSelectPlatformId(product_platform_id, option) {
            this.model.advertiser_ids = [option.data.attrs.advertiser_id]
            //需要从this.productConfigs找出product_platform_id对应的
            let item = option.data.attrs.val

            this.model.price_info.price = item.price
            this.model.profession.max_charge = item.max_charge
            this.model.profession.min_charge = item.min_charge
            this.model.profession.recommended_charge = item.recommended_charge

            // console.log('aaa', item)
            // console.log('changeSelectPlatformId', this.model.advertiser_ids)
            this.changePlatformId()
        },
        filterOption(input, option) {
            const name = option.componentOptions.children[0].text.toLowerCase();
            const platformId = String(option.componentOptions.propsData.value);
            return (
              name.includes(input.toLowerCase()) || platformId.includes(input)
            );
        },
        changeProductType(product_type) {
            //需要获取对应关系
            getProductConfigs({type:product_type}).then(res => { this.productConfigs = res.data.list || [] })
            this.model.advertiser_ids = []
            this.model.product_platform_id = null
        }
    }
}
